// extracted by mini-css-extract-plugin
module.exports = {"priceDetailContainer":"PricesDetail_priceDetailContainer__1gswk","priceDetailInfo":"PricesDetail_priceDetailInfo__267Hg"};